<template>
  <div>
    <div class="space-for-navigation-bar"></div>
    <header-title :title="$t('purchase.cardInfomation')" class="title" />
    <div v-if="Object.keys(sources).length == 0">
      <div class="input-container">
        <div class="row-inputForm">
          <label for="name" class="label">{{ $t("purchase.name") }}</label>
          <input
            type="text"
            id="cardName"
            maxlength="16"
            class="form-control name"
            placeholder="TARO TANAKA"
          />
        </div>
        <div class="row-inputForm">
          <label for="" class="label">{{ $t("purchase.cardNumber") }}</label>
          <input
            type="text"
            maxlength="19"
            class="card-number form-control"
            placeholder="1234 1234 1234 1234"
            v-model="cardNumber"
          />
        </div>
        <div class="row-inputForm">
          <label for="height" class="label">{{
            $t("purchase.expirationDate")
          }}</label>
          <input
            type="text"
            maxlength="4"
            class="form-control"
            :placeholder="$t('purchase.expirationCaption')"
            v-model="limit"
          />
        </div>
        <div class="row-inputForm">
          <label for="height" class="label">{{ $t("purchase.cvcText") }}</label>
          <input
            type="text"
            maxlength="3"
            class="card-number form-control"
            placeholder="123"
            v-model="cvc"
          />
        </div>
        <next-button
          :label="$t('common.register')"
          :disabled="false"
          @click.prevent="toggleCheckOutButton"
        />
      </div>
    </div>
    <div v-else>
      <div v-if="charge">
        <Progress :title="$t('aiPredictionReport.analyzing')" />
      </div>
      <div v-else>
        <div class="input-container">
          <div class="row-inputForm">
            <label for="height" class="label">{{
              $t("purchase.patmentCard")
            }}</label>
            {{ getCardNum }}
          </div>
          <next-button
            :label="getFee"
            :disabled="false"
            @click.prevent="submitNewCharge"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
Stripe.setPublishableKey(process.env.VUE_APP_STRIPE_PUB_KEY);
import { db } from "../../../firebase";
import Progress from "../../atoms/Progress";
import HeaderTitle from "../../../design/HeaderTitleSlot";
import NextButton from "../../../components/atoms/NextButton";

export default {
  components: {
    HeaderTitle,
    Progress,
    NextButton,
  },
  data() {
    return {
      checkOutButton: false,
      fee: 5000,
      cardNumber: null,
      limit: null,
      cvc: null,
      sources: {},
      source: null,
      charge: false,
    };
  },
  created() {
    this.listen();
  },
  methods: {
    listen() {
      // 初回登録時のsouceデータ取得
      db.ref(`/stripe_customers/${this.$store.state.auth.user.uid}/sources`).on(
        "value",
        (snapshot) => {
          if (snapshot.val()) {
            this.sources = snapshot.val();
            this.checkOutButton = true;
          } else {
            this.sources = {};
            this.checkOutButton = false;
          }
        },
        () => {
          this.sources = {};
          this.checkOutButton = false;
        }
      );
      // 診断処理の結果を取得
      db.ref(`/stripe_customers/${this.$store.state.auth.user.uid}/charges`).on(
        "child_changed",
        (snapshot) => {
          if (this.charge) {
            if (snapshot.val()) {
              const res = snapshot.val();
              if (res.process_status && res.process_status == "QeryError") {
                alert(
                  this.$t("aiPredictionReport.failedToSaveTheDiagnoisOnServer")
                );
              }
            }
          }
        },
        () => {
          // エラー 支払い成功で診断失敗の場合の処理を要検討
          alert(this.$t("purchase.failedPurchase"));
        }
      );
      // selvyからの診断結果を取得
      db.ref(
        `/selvy/${this.$store.state.auth.user.uid}/${
          this.$store.getters["karte/getDiagnosisDate"]
        }`
      ).on(
        "value",
        (snapshot) => {
          if (this.charge) {
            // ページ遷移
            alert(this.$t("aiPredictionReport.analyzeSuccess"));
            const diagnosisDate = this.$store.getters["karte/getDiagnosisDate"];
            this.$store.dispatch("selvy/setDiagnosisDate", {
              date: diagnosisDate,
            });
            this.$router.push({ name: "report" });
          }
        },
        () => {
          // エラー 支払い成功で診断失敗の場合の処理を要検討
          alert(this.$t("aiPredictionReport.failedToSaveTheDiagnoisOnServer"));
        }
      );
    },
    toggleCheckOutButton() {
      Stripe.card.createToken(
        {
          number: this.cardNumber,
          cvc: this.cvc,
          exp_month: this.limit.slice(0, 2),
          exp_year: this.limit.slice(3, 5),
        },
        (status, response) => {
          if (response.error) {
            alert(this.$t("purchase.invalidPurchase") + response.error.message);
          } else {
            // 登録情報をFirebaseに登録する
            db.ref(
              `/stripe_customers/${this.$store.state.auth.user.uid}/sources`
            )
              .push({ token: response.id })
              .then(() => {
                this.cardNumber = "****************";
                this.cvc = "***";
                this.limit = "**/**";
                this.checkOutButton = true;
              });
          }
        }
      );
    },
    async submitNewCharge() {
      try {
        // karteデータ登録
        await this.$store.dispatch(
          "karte/sendKarteToFirebaseByCharge",
          this.$store.state.auth.user.uid
        );
        // 支払い実行
        if (this.source) {
          await db
            .ref(`/stripe_customers/${this.$store.state.auth.user.uid}/charges`)
            .push({
              source: this.source,
              diagnosis_date: this.$store.getters["karte/getDiagnosisDate"],
            });
          this.charge = true;
        } else {
          alert(this.$t("purchase.failedPurchase"));
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        alert(this.$t("aiPredictionReport.failedToSaveTheDiagnoisOnServer"));
        console.log(error.message);
      }
    },
  },
  computed: {
    culcFee() {
      // test
      if (this.discountCode) {
        return this.fee * this.discountRage;
      } else {
        return this.fee;
      }
    },
    getFee() {
      return this.$t("purchase.purchase") + "¥" + this.culcFee.toLocaleString();
    },
    getCardNum() {
      for (const [key, value] of Object.entries(this.sources)) {
        this.source = value.id;
        return (
          value.brand +
          "  " +
          this.$t("purchase.selectCard") +
          "  ..." +
          value.last4 +
          "  exp.  " +
          value.exp_month +
          "/" +
          value.exp_year
        );
      }
      return "";
    },
  },
  filters: {
    toLocale(val) {
      return val.toLocaleString();
    },
  },
  watch: {
    cardNumber: function() {
      this.cardNumber = this.cardNumber.replace(/(\d{4})(?=(\d{4})+$)/g, "$1 ");
    },
    limit: function() {
      this.limit = this.limit.replace(/(\d{2})(?=(\d{2})+$)/, "$1\/");
    },
  },
};
</script>

<style scoped>
/*navigation barと「カード情報」の間の余白*/
.space-for-navigation-bar {
  height: 60px;
}
/* 入力フォーム外周コンテナ */
.input-container {
  margin: auto;
  border: 1px solid #e7e6e7;
  padding: 40px;
  border-radius: 10px;
  margin-top: 40px;
}

.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(112.5% + 0.25vw);
}

.form-control-select {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 40px;
  font-size: calc(100% + 0.25vw);
}

.row-inputForm {
  display: grid;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  grid-template-columns: 1fr 4.5fr;
}

/* エラー表記用 */
.invalid {
  border-color: red;
}
</style>
